import { render, staticRenderFns } from "./CowsDehorningSecondPage.vue?vue&type=template&id=276422e7&scoped=true&"
import script from "./CowsDehorningSecondPage.vue?vue&type=script&lang=js&"
export * from "./CowsDehorningSecondPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276422e7",
  null
  
)

export default component.exports